// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2BePm","label":"Radio_label__1hIDs","checkMark":"Radio_checkMark__ISSIw","disabled":"Radio_disabled__GQ1LP"};